import React, { useEffect, useState } from "react";
import { sortArrayObject, sortArrayObjectNumber } from "../utils/array";
import LeaderBoardCardWrapper from "../leaderboard-card/leaderboard-card-wrapper";
import { http } from "../utils/http";
import Navbar from "../components/Navbar/Navbar";

const BASE_URL = "GET /repos/{owner}/{repo}/contributors";

const repo = [
  {
    projectName: "Prime Hack",
    owner: "itkisthub",
    repo: "Prime-Hack",
    college: "Prime College",
  },
  {
    projectName: "Hack Wizards",
    owner: "itkisthub",
    repo: "Hack-Wizards",
    college: "NCIT College",
  },
  {
    projectName: "Team SDC",
    owner: "itkisthub",
    repo: "Team-SDC",
    college: "Shanker dev Campus",
  },

  {
    projectName: "Team Vision",
    owner: "itkisthub",
    repo: "Team-Vision",
    college: "Nagarjuna College",
  },
  {
    projectName: "Khata",
    owner: "itkisthub",
    repo: "Khata",
    college: "Trinity",
  },
  {
    projectName: "Tech Ninja",
    owner: "itkisthub",
    repo: "Tech-Ninja",
    college: "Phoenix",
  },

  {
    projectName: "ZenNest",
    owner: "itkisthub",
    repo: "ZenNest",
    college: "KIST",
  },
  {
    projectName: "Thames",
    owner: "itkisthub",
    repo: "Thames",
    college: "Thames",
  },
  {
    projectName: "Superlatives",
    owner: "itkisthub",
    repo: "Superlatives",
    college: "Softwarica",
  },
  {
    projectName: "Lucifer",
    owner: "itkisthub",
    repo: "Lucifer",
    college: "Lord Buddha",
  },
  {
    projectName: "Find x",
    owner: "itkisthub",
    repo: "Find-x",
    college: "KEC",
  },
  {
    projectName: "Top of Stack",
    owner: "itkisthub",
    repo: "Top-of-Stack",
    college: "KEC",
  },

  {
    projectName: "Code Finty",
    owner: "itkisthub",
    repo: "Code-Finty",
    college: "Lord Buddha",
  },

  {
    projectName: "Zen2",
    owner: "itkisthub",
    repo: "Zen2",
    college: "Lord Buddha",
  },

  {
    projectName: "Arunima",
    owner: "itkisthub",
    repo: "Arunima",
    college: "Arunima College",
  },
  {
    projectName: "New Summit 2",
    owner: "itkisthub",
    repo: "New-Summit-2",
    college: "New Summit",
  },

  {
    projectName: "New Summit 1",
    owner: "itkisthub",
    repo: "New-Summit-1",
    college: "New Summit",
  },

  {
    projectName: "InnoVisionX",
    owner: "itkisthub",
    repo: "InnoVisionX",
    college: "Softwarica",
  },

  {
    projectName: "HARK",
    owner: "itkisthub",
    repo: "HARK",
    college: "KIST College",
  },
  {
    projectName: "Team 404",
    owner: "itkisthub",
    repo: "Team-404",
    college: "Softwarica College of IT and E-Commerce",
  },
  {
    projectName: "Leaf Node",
    owner: "itkisthub",
    repo: "Leaf-Node",
    college: "St. Xavier's College",
  },
];

export default function Groups() {
  const [projectList, setProjectList] = useState([]);
  const [topThreeContributors, setTopThreeContributors] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchContributors = async (item) => {
    const response = await http.request(BASE_URL, {
      owner: item.owner,
      repo: item.repo,
    });

    return response;
  };

  const getData = async () => {
    Promise.all(
      repo?.map((item) => {
        return fetchContributors({
          owner: item.owner,
          repo: item.repo,
        });
      })
    ).then((values) => {
      if (values) {
        const data = constructFinalValue(values);
        setProjectList(data);
        setLoading(false);
      }
    });
  };

  const constructFinalValue = (users) => {
    if (!users) return [];

    const data = users?.map((user, index) => {
      const flatUsers = user?.data?.map((item) => item?.contributions);
      let totalContribution = 0;

      if (!flatUsers || !flatUsers?.length) {
        return {
          rank: 1,
          users: [],
          projectName: repo[index]?.projectName || "-",
          collegeName: repo[index]?.college,
          totalContribution: 0,
        };
      }
      const maxContribution = Math.max(...flatUsers);
      const data = user?.data?.map((item) => {
        totalContribution += item?.contributions;
        if (maxContribution === item?.contributions) {
          return { isMVP: true, projectName: repo[index], ...item };
        }
        return item;
      });

      return {
        totalContribution,
        rank: index + 1,
        users: data,
        collegeName: repo[index]?.college,
        projectName: repo[index]?.projectName || "-",
      };
    });

    return data;
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const _all_data = projectList;
    const flatData = _all_data.flat();

    const sortedArr = sortArrayObject(flatData, "contributions");
    if (sortedArr.length > 0) {
      const [first, second, third, ...rest] = sortedArr;
      setTopThreeContributors([first, second, third]);
    }
  }, [projectList]);

  console.log("projectList>>>", projectList);

  return (
    <div className="page-container">
      <div className="group-wrapper">
        <div className="header">
          <span className="page-title">KIST HACKATHON</span>
          <Navbar />
        </div>
        {/* <RankerWrapper topThreeContributors={topThreeContributors} /> */}
        <div className="leaderboard-wrapper">
          {loading && <div>Loading...</div>}
          <LeaderBoardCardWrapper
            projectList={sortArrayObjectNumber(
              projectList,
              "totalContribution"
            )}
          />
        </div>
      </div>
    </div>
  );
}
